var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGreyCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 9.00356C17 4.50134 13.3503 0.851562 8.84805 0.851562C4.34582 0.851562 0.696045 4.50134 0.696045 9.00356C0.696045 13.5058 4.34582 17.1556 8.84805 17.1556C13.3503 17.1556 17 13.5058 17 9.00356Z",
    fill: "#3d4d69"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.40803 11.0867C7.37004 11.0867 7.33251 11.0784 7.29799 11.0626C7.26347 11.0467 7.23279 11.0235 7.20804 10.9947L5.81203 9.48072C5.78781 9.45407 5.76906 9.4229 5.75688 9.389C5.7447 9.3551 5.73932 9.31912 5.74103 9.28314C5.74275 9.24716 5.75154 9.21187 5.7669 9.17928C5.78226 9.1467 5.80388 9.11745 5.83054 9.09322C5.85719 9.06899 5.88836 9.05025 5.92226 9.03807C5.95616 9.02589 5.99214 9.0205 6.02812 9.02222C6.0641 9.02394 6.09939 9.03273 6.13198 9.04808C6.16457 9.06344 6.19381 9.08507 6.21804 9.11172L7.41804 10.4117L10.74 7.09872C10.7651 7.07246 10.7952 7.05156 10.8285 7.03727C10.8619 7.02299 10.8978 7.01562 10.934 7.01562C10.9703 7.01562 11.0062 7.02299 11.0396 7.03727C11.0729 7.05156 11.103 7.07246 11.128 7.09872C11.1791 7.15039 11.2077 7.22009 11.2077 7.29272C11.2077 7.36536 11.1791 7.43506 11.128 7.48672L7.60303 11.0027C7.57864 11.0301 7.54854 11.0518 7.51485 11.0664C7.48116 11.0809 7.4447 11.0878 7.40803 11.0867Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyCheck);
export default __webpack_public_path__ + "static/media/grey_check.680759d5.svg";
export { ForwardRef as ReactComponent };